import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _typeof from "@babel/runtime/helpers/typeof";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import DeepEqual from 'fast-deep-equal';
import SearchMenuItem from './SearchMenuItem';
import { tempRefs, INITIAL_STATE, MENU_ITEMS } from './constants';
import { analyticsTrack } from '../../../analyticsUtils';
import './SearchFilterMenu.scss';
var transformSelectionObjectData = function transformSelectionObjectData(selection) {
  return selection.map(function (sel) {
    if (_typeof(sel) === 'object') {
      return sel.label;
    }
    return sel;
  });
};
var getSubmenuData = function getSubmenuData(_ref) {
  var therapeuticAreas = _ref.therapeuticAreas,
    industries = _ref.industries,
    productTechnologies = _ref.productTechnologies,
    developmentPhases = _ref.developmentPhases,
    yearsOfExperience = _ref.yearsOfExperience,
    hourlyRate = _ref.hourlyRate,
    seniorityLevels = _ref.seniorityLevels,
    roles = _ref.roles;
  return {
    Role: {
      Role: roles
    },
    Expertise: {
      'Functional Area': [{
        value: 1,
        label: 'Clinical Operations'
      }],
      'Therapeutic Areas': therapeuticAreas,
      'Product Technologies': productTechnologies,
      Diseases: [],
      'Phases of Development': developmentPhases,
      Industries: industries,
      Keyword: null
    },
    Seniority: {
      'Years of Experience': yearsOfExperience,
      'Seniority Level': seniorityLevels
    },
    'Work Preferences': {
      'Hourly Rate': hourlyRate,
      Availability: false,
      // Location: location,
      Languages: []
    }
  };
};
var doesStateHaveSelection = function doesStateHaveSelection(selections) {
  return !DeepEqual(INITIAL_STATE.selections, selections);
};
var SearchFilterMenu = /*#__PURE__*/function (_PureComponent) {
  function SearchFilterMenu(props) {
    var _this;
    _classCallCheck(this, SearchFilterMenu);
    _this = _callSuper(this, SearchFilterMenu, [props]);
    _this.state = INITIAL_STATE;
    _this.sliderResetFunctions = [];
    _this.data = getSubmenuData(props);
    _this.handleChange = _this.handleChange.bind(_this);
    _this.handleSelection = _this.handleSelection.bind(_this);
    _this.removeSelection = _this.removeSelection.bind(_this);
    _this.clearFilters = _this.clearFilters.bind(_this);
    _this.handlestateRepopulation = _this.handleStateRepopulation.bind(_this);
    _this.registerSliderResetFunction = _this.registerSliderResetFunction.bind(_this);
    return _this;
  }
  _inherits(SearchFilterMenu, _PureComponent);
  return _createClass(SearchFilterMenu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var params = this.props.params;
      var hasParams = Object.keys(params).length > 2;
      if (hasParams) {
        this.handleStateRepopulation();
      }
    }
  }, {
    key: "handleStateRepopulation",
    value: function handleStateRepopulation() {
      var params = this.props.params;
      var stateCopy = this.state;
      var paramValues = tempRefs.reduce(function (prev, curr) {
        if (curr.name === 'Keyword') {
          return [].concat(_toConsumableArray(prev), [{
            name: curr.name,
            parent: curr.parent,
            value: params[curr.name] || null
          }]);
        }
        return [].concat(_toConsumableArray(prev), [{
          name: curr.name,
          parent: curr.parent,
          value: params[curr.name] ? JSON.parse(params[curr.name]) : []
        }]);
      }, []);
      for (var i = 0, ii = paramValues.length; i < ii; i += 1) {
        stateCopy = _objectSpread(_objectSpread({}, stateCopy), paramValues[i].parent ? {
          selections: _objectSpread(_objectSpread({}, stateCopy.selections), {}, _defineProperty({}, paramValues[i].parent, _objectSpread(_objectSpread({}, stateCopy.selections[paramValues[i].parent]), {}, _defineProperty({}, paramValues[i].name, paramValues[i].value))))
        } : {
          selections: _objectSpread(_objectSpread({}, stateCopy.selections), {}, _defineProperty({}, paramValues[i].name, paramValues[i].value))
        });
      }
      this.setState(stateCopy);
    }
  }, {
    key: "handleChange",
    value: function handleChange(menuTitle, submenuTitle, value) {
      var selections = this.state.selections;
      var setSelectionState = this.props.setSelectionState;
      var newState = {
        selections: _objectSpread(_objectSpread({}, selections), {}, _defineProperty({}, menuTitle, _objectSpread(_objectSpread({}, selections[menuTitle]), {}, _defineProperty({}, submenuTitle, value))))
      };
      this.setState(newState, function () {
        if (submenuTitle !== 'Keyword') setSelectionState(newState.selections);
      });
    }
  }, {
    key: "handleSelection",
    value: function handleSelection(menuTitle, selection, subsection) {
      var _this2 = this;
      var setSelectionState = this.props.setSelectionState;
      var selections = this.state.selections;
      var doesSelectionExist;
      analyticsTrack("Filtered by ".concat(subsection), {
        location: 'Search Index'
      });
      if (Array.isArray(selection)) {
        this.setState(_objectSpread({}, subsection ? {
          selections: _objectSpread(_objectSpread({}, selections), {}, _defineProperty({}, menuTitle, _objectSpread(_objectSpread({}, selections[menuTitle]), {}, _defineProperty({}, subsection, transformSelectionObjectData(selection)))))
        } : {
          selections: _objectSpread(_objectSpread({}, selections), {}, _defineProperty({}, menuTitle, transformSelectionObjectData(selection)))
        }), function () {
          return setSelectionState(_this2.state.selections);
        });
        return;
      }
      if (subsection) {
        doesSelectionExist = selections[menuTitle][subsection].includes(selection);
        if (!doesSelectionExist) {
          this.setState({
            selections: _objectSpread(_objectSpread({}, selections), {}, _defineProperty({}, menuTitle, _objectSpread(_objectSpread({}, selections[menuTitle]), {}, _defineProperty({}, subsection, [].concat(_toConsumableArray(selections[menuTitle][subsection]), [selection])))))
          }, function () {
            return setSelectionState(_this2.state.selections);
          });
          return;
        }
        this.removeSelection(menuTitle, selection, subsection);
        return;
      }
      doesSelectionExist = selections[menuTitle].includes(selection);
      if (!doesSelectionExist) {
        this.setState({
          selections: _objectSpread(_objectSpread({}, selections), {}, _defineProperty({}, menuTitle, [].concat(_toConsumableArray(selections[menuTitle]), [selection])))
        }, function () {
          return setSelectionState(_this2.state.selections);
        });
        return;
      }
      this.removeSelection(menuTitle, selection);
    }
  }, {
    key: "removeSelection",
    value: function removeSelection(menuTitle, _selection, subsection) {
      var _this3 = this;
      var setSelectionState = this.props.setSelectionState;
      var selections = this.state.selections;
      this.setState(_objectSpread({}, subsection ? {
        selections: _objectSpread(_objectSpread({}, selections), {}, _defineProperty({}, menuTitle, _objectSpread(_objectSpread({}, selections[menuTitle]), {}, _defineProperty({}, subsection, Array.isArray(_selection) ? [] : selections[menuTitle][subsection].filter(function (selection) {
          if (_typeof(_selection) === 'object') {
            return selection.label !== _selection.label;
          }
          return selection !== _selection;
        })))))
      } : {
        selections: _objectSpread(_objectSpread({}, selections), {}, _defineProperty({}, menuTitle, selections[menuTitle].filter(function (selection) {
          if (_typeof(_selection) === 'object') {
            return selection.label !== _selection.label;
          }
          return selection !== _selection;
        })))
      }), function () {
        return setSelectionState(_this3.state.selections);
      });
    }
  }, {
    key: "registerSliderResetFunction",
    value: function registerSliderResetFunction(func) {
      this.sliderResetFunctions.push(func);
    }
  }, {
    key: "clearFilters",
    value: function clearFilters() {
      var _this4 = this;
      var clearParams = this.props.clearParams;
      this.setState(INITIAL_STATE, function () {
        clearParams();
        _this4.sliderResetFunctions.forEach(function (func) {
          return func();
        });
        analyticsTrack('Clicked Clear Filters', {
          location: 'Search Index'
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;
      var selections = this.state.selections;
      var setSelectionState = this.props.setSelectionState;
      var hasSelection = doesStateHaveSelection(selections);
      return /*#__PURE__*/React.createElement("div", {
        className: "search-filter-menu"
      }, /*#__PURE__*/React.createElement("div", {
        className: "header"
      }, /*#__PURE__*/React.createElement("i", {
        className: "fas fa-filter"
      }), "Filter by:", hasSelection && /*#__PURE__*/React.createElement("span", {
        className: "body-text-2 demibold clear-filters-top",
        role: "link",
        tabIndex: 0,
        onClick: this.clearFilters
      }, "Clear All")), /*#__PURE__*/React.createElement("div", {
        className: "menu-divider"
      }), MENU_ITEMS.map(function (name) {
        return /*#__PURE__*/React.createElement(Fragment, {
          key: name
        }, /*#__PURE__*/React.createElement(SearchMenuItem, {
          name: name,
          structuralData: _this5.data[name],
          selectionData: selections,
          handleSelection: _this5.handleSelection,
          removeSelection: _this5.removeSelection,
          handleChange: _this5.handleChange,
          setSelectionState: setSelectionState,
          registerSliderResetFunction: _this5.registerSliderResetFunction
        }), /*#__PURE__*/React.createElement("div", {
          className: "item-divider"
        }));
      }), /*#__PURE__*/React.createElement("div", {
        className: "clear-filters-footer",
        role: "button",
        tabIndex: 0,
        onClick: this.clearFilters
      }, "Clear Filters"));
    }
  }]);
}(PureComponent);
SearchFilterMenu.propTypes = {
  params: PropTypes.shape({}).isRequired,
  setSelectionState: PropTypes.func.isRequired,
  clearParams: PropTypes.func.isRequired
};
export default SearchFilterMenu;